import React, { Component } from 'react';

type LoadingButtonBaseProps = {
    className?: string;
    loading: boolean;
    label: string;
    onClick?(): void;
};

export default class LoadingButtonBase extends Component<LoadingButtonBaseProps> {

    static displayName = LoadingButtonBase.name;

    render() {
        let buttonClass = this.props.loading ? "btn-disabled" : "btn-primary";
        if (this.props.className) {
            buttonClass = `${this.props.className} ${buttonClass}`;
        }
        return (
            <button className={buttonClass} onClick={this.props.onClick} disabled={this.props.loading}>
                {this.props.loading ? "Loading..." : this.props.label}
            </button>
        );
    }
}
